/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { Card, LinearProgress, Stack } from "@mui/material";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiProgress from "components/VuiProgress";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import linearGradient from "assets/theme/functions/linearGradient";

// Vision UI Dashboard React base styles
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";

// Dashboard layout components
import WelcomeMark from "layouts/dashboard/components/WelcomeMark";
import Projects from "layouts/dashboard/components/Projects";
import OrderOverview from "layouts/dashboard/components/OrderOverview";
import SatisfactionRate from "layouts/dashboard/components/SatisfactionRate";
import ReferralTracking from "layouts/dashboard/components/ReferralTracking";

// React icons
import { IoIosRocket } from "react-icons/io";
import { IoGlobe, IoPeople } from "react-icons/io5";
import { IoBuild } from "react-icons/io5";
import { IoWallet } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { FaShoppingCart } from "react-icons/fa";
import { IoCash } from "react-icons/io5";
import Transactions from "layouts/billing/components/Transactions";
import { getAuth } from "firebase/auth";
import { CreditUser, GetReferralData, GetUserData, ReferralData, UserData, getTotalPlan } from "Api";
import { useEffect, useState } from "react";
import { Spin } from "antd";

function Dashboard() {
  const { gradients } = colors;
  const { cardContent } = gradients;
  const auth =  getAuth();
  const [userData, setData] = useState(UserData.emtpy());
  const [referralData, setReferralData] = useState(ReferralData.emtpy());
  const [balance, setBalance] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const auth = getAuth();
   const sub = auth.onAuthStateChanged((user) => {
    if(user){
        fetchData(user.uid);
    }
   })

   return () =>{
    sub()
   }
  }, []);

  async function  fetchData (uid) {
    console.log("fetched data");
    CreditUser(uid)
    const data = await GetUserData(uid);
    GetReferralData(uid).then((referralData) => {
      if(referralData){
        setReferralData(referralData);
      }
    });
    getTotalPlan(uid).then((bal) => {
      console.log(bal)
      setBalance((bal * 1) + (data.balance * 1))
    })
    setData(data);
   if (data) {
     setLoaded(true);
   }else{
     fetchData(uid);
   }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
    <Spin spinning={!loaded}>
    <VuiBox py={3}>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Plan", fontWeight: "regular" }}
                count={userData.plan.name}
                icon={{ color: "info", component:  <IoGlobe size="22px" color="white" /> }}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Balance" }}
                count={`$${balance}`}
                percentage={{ color: "success", text: `+${userData.plan.Profits}%` }}
                icon={{ color: "info", component: <IoWallet size="22px" color="white" />}}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Refferals" }}
                count={referralData.referredUsers.length}
                icon={{ color: "info", component: <IoPeople size="22px" color="white" /> }}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Withdrawable Balance" }}
                count={`$${userData.balance}`}
                percentage={{ color: "success", text: `+${userData.plan.Profits}%` }}
                icon={{ color: "info", component: <IoCash size="20px" color="white" /> }}
              />
            </Grid>
          </Grid>
        </VuiBox>
        <VuiBox mb={3}>
          <Grid container spacing="18px">
          <Grid item xs={12} md={6} lg={8}>
          <Transactions />
          </Grid>
            <Grid item xs={12} lg={6} xl={4}>
              <ReferralTracking people={referralData.referredUsers.length} />
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
    </Spin>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
